import {
    FormControl,
    Checkbox,
    FormGroup,
    Typography,
    Box,
    FormHelperText,
} from '@mui/material';
import { FormikProps } from 'formik';
import { FormValuesB2B } from '../FormPageB2B';
import { useLanguage } from '../i18n/LanguageContext';

const AgreementB2B = ({ formik }: { formik: FormikProps<FormValuesB2B> }) => {
    const { t } = useLanguage();
    return (
        <Box mt={10} >
            <FormGroup>
                <FormControl
                    error={formik.touched.dataAgreement && Boolean(formik.errors.dataAgreement)}
                    sx={{ mb: 2 }}
                >
                    <Box display="flex">
                        <Box>
                            <Checkbox
                                key="dataAgreement"
                                name="dataAgreement"
                                checked={formik.values.dataAgreement}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                sx={{
                                    p: 0.5,
                                    ...(formik.touched.dataAgreement && formik.errors.dataAgreement
                                        ? {
                                            color: 'error.main',
                                            '&.Mui-checked': { color: 'error.main' },
                                        }
                                        : {
                                            color: 'primary.main',
                                            '&.Mui-checked': { color: 'primary.main' },
                                        }),
                                }}
                            />
                        </Box>
                        <Box ml={1}>
                            <Typography variant="body1">
                                {t('agreement.dataAgreement')}
                            </Typography>
                        </Box>
                    </Box>
                    {formik.touched.dataAgreement && formik.errors.dataAgreement && (
                        <FormHelperText>{formik.errors.dataAgreement}</FormHelperText>
                    )}
                </FormControl>
                {/* Checkbox 2 */}
                <FormControl
                    error={
                        formik.touched.personalDataProcessingConsent &&
                        Boolean(formik.errors.personalDataProcessingConsent)
                    }
                    sx={{ mb: 2 }}
                >
                    <Box display="flex">
                        <Box>
                            <Checkbox
                                key="personalDataProcessingConsent"
                                name="personalDataProcessingConsent"
                                checked={formik.values.personalDataProcessingConsent}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                sx={{
                                    p: 0.5,
                                    ...(formik.touched.personalDataProcessingConsent &&
                                        formik.errors.personalDataProcessingConsent
                                        ? {
                                            color: 'error.main',
                                            '&.Mui-checked': { color: 'error.main' },
                                        }
                                        : {
                                            color: 'primary.main',
                                            '&.Mui-checked': { color: 'primary.main' },
                                        }),
                                }}
                            />
                        </Box>
                        <Box ml={1}>
                            <Typography variant="body1">
                                {t('agreement.processingConsent')}
                            </Typography>
                        </Box>
                    </Box>
                    {formik.touched.personalDataProcessingConsent &&
                        formik.errors.personalDataProcessingConsent && (
                            <FormHelperText>{formik.errors.personalDataProcessingConsent}</FormHelperText>
                        )}
                </FormControl>
            </FormGroup>
        </Box>
    );
};

export default AgreementB2B;
